import { render, staticRenderFns } from "./xinpengdaojiaDetails.vue?vue&type=template&id=b2e9643c"
import script from "./xinpengdaojiaDetails.vue?vue&type=script&lang=js"
export * from "./xinpengdaojiaDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports